import FirestoreModelManager from "./manager/FirestoreModelManager";
const ModelManager = new FirestoreModelManager();
export default ModelManager;